import { RootState } from '../Store';

export const selectMarketplaceProfiles = (state: RootState) => state.marketplace.profiles;
export const selectActiveFilter = (state: RootState) => state.marketplace.activeFilter;
export const selectActiveSort = (state: RootState) => state.marketplace.activeSort;
export const selectUserBalance = (state: RootState) => state.marketplace.userBalance;
export const selectSelectedProfile = (state: RootState) => state.marketplace.selectedProfile;
export const selectMarketplacePagination = (state: RootState) => state.marketplace.pagination;
export const selectMarketplaceLoading = (state: RootState) => state.marketplace.isLoading;
export const selectMarketplaceError = (state: RootState) => state.marketplace.error;
